import React from 'react';

const Newsletter = () => {
  return (
    <section id="subscribe">
      <iframe
        src="https://www.fundera.com/embed/newsletter"
        title="Newsletter"
        width="100%"
        type="text/html"
        frameBorder="0"
        // eslint-disable-next-line react/no-unknown-property
        allowtransparency="true"
        loading="lazy"
        style={{ border: 0, scrolling: 'no' }}
      />
    </section>
  );
};

export default Newsletter;
